import { Tag } from '~/games/types/games.types'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

import { GameTag } from './GameTag'
import { PlayButton } from './PlayButton'

const mediaQuery = [
  { screen: '(max-width: 767px)', width: '20vw' },
  { screen: '(min-width: 768px)', width: '30vw' },
]

export function GameCard({
  backgroundUrl,
  backgroundPosition = 'center',
  gameEndpoint,
  from,
  ingress,
  logo,
  tags,
  title,
  height,
  width,
  className,
}: {
  backgroundUrl?: string
  backgroundPosition?: string
  gameEndpoint: string
  from?: string
  ingress: any
  logo: string
  tags: Tag[]
  title: string
  height: number
  width: number
  className?: string
}): React.ReactElement {
  const backgroundStyle = {
    background: `url(${backgroundUrl}) no-repeat ${backgroundPosition} center fixed`,
    backgroundSize: 'cover',
  }

  return (
    <div className="bg-white flex w-full max-w-132 max-h-64 rounded shadow-experimental">
      <div className="flex w-1/3 items-center justify-center bg-blue-light rounded-l" style={backgroundStyle}>
        <ResponsiveImage
          alt={title}
          height={height}
          imageClassName={className ? className : 'px-2.5'}
          mediaQuery={mediaQuery}
          srcKey={logo}
          width={width}
        />
      </div>
      <div className="p-4 space-y-2 w-2/3">
        <div className="flex flex-wrap gap-x-2 gap-y-1">
          {tags.map((tag) => (
            <GameTag
              bg={tag.bg}
              color={tag.color}
              iconName={tag.iconName ?? tag.iconName}
              key={tag.id}
              name={tag.name}
            />
          ))}
        </div>
        <div className="flex flex-col">
          <h5 className="text-sm md:text-lg font-medium">{title}</h5>
          <p className="pb-4 text-2.5 md:text-sm text-gray-sub-text font-light whitespace-pre-line">{ingress}</p>

          <PlayButton from={from} gameEndpoint={gameEndpoint} />
        </div>
      </div>
    </div>
  )
}
